import { Breadcrumb, Button, Tooltip } from "antd";
import { HomeOutlined, RightOutlined } from "@ant-design/icons";

export default function NavigationBreadcrumb({ currentPath, onNavigate }) {
  const breadcrumbItems = [
    {
      title: (
        <Button
          type="link"
          size="small"
          icon={<HomeOutlined />}
          onClick={() => onNavigate(null)}
          style={{ padding: 0, fontSize: "14px" }}
        >
          Inicio
        </Button>
      ),
    },
    ...currentPath.map((carpeta) => ({
      key: carpeta.id,
      title: (
        <Tooltip title={carpeta.nombre}>
          <Button
            type="link"
            size="small"
            onClick={() => onNavigate(carpeta)}
            style={{
              padding: 0,
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
              fontSize: "14px",
            }}
          >
            {carpeta.nombre}
          </Button>
        </Tooltip>
      ),
    })),
  ];

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        overflowX: "auto",
        paddingBottom: 8,
        marginBottom: 16,
      }}
    >
      <Breadcrumb
        separator={<RightOutlined style={{ fontSize: "12px", color: "#bfbfbf" }} />}
        items={breadcrumbItems}
      />
    </div>
  );
}
